var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('bb-navbar',{attrs:{"sticky":"","flavor":"public","close-button":_vm.isAuthenticatedApplicant,"logo-to":"https://www.bigbank.fi/"},on:{"closeClick":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }